import { Component, OnInit, Output, EventEmitter, Input, OnDestroy } from '@angular/core';
import { CommonModule, KeyValue } from '@angular/common';
import { Subscription } from 'rxjs';
import { Breadcrumb } from 'src/app/models/breadcrumb.model';
import { BreadcrumbService } from 'src/app/services/breadcrumb.service';

@Component({
  standalone: true,
  selector: 'app-crumb',
  templateUrl: './crumb.component.html',
  styleUrls: ['./crumb.component.scss'],
  imports: [ CommonModule ]
})

export class CrumbComponent implements OnInit, OnDestroy {
  public crumbLabel = '';
  @Input() enableSwitchTo: boolean;
  @Input() crumb: Breadcrumb;
  @Input() isactive: boolean;
  @Output() crumbClicked: EventEmitter<KeyValue<string, string>> = new EventEmitter();
  private $subscriptions: Subscription = new Subscription();
  public crumbClass = 'pi pi-chevron-right breadcrumb-item';
  private _displayLinks = true;
  private _displayShortcuts = false;

  get displayLinks(): boolean {
    return this._displayLinks;
  }

  get displayShortcuts(): boolean {
    return this._displayShortcuts;
  }

  constructor(private breadcrumbService: BreadcrumbService) {
    this.enableSwitchTo = true;
  }

  ngOnInit() {
    this.crumbLabel = this.crumb.Label;
    this.setCrumbClass();
    this.setDisplayLinks();
    this.setDisplayShortcuts();
    this.subscribeToShortcutChanges();
  }

  private subscribeToShortcutChanges() {
    const crumbShortcutsSubscription = this.breadcrumbService.crumbShortcutsChanged$
      .subscribe(crumb => {
        // any action needed
      });
    this.$subscriptions.add(crumbShortcutsSubscription);
  }

  private setDisplayLinks() {
    this._displayLinks = (this.crumb) ? true : false;
  }

  private setDisplayShortcuts() {
    const permId = this.crumb?.Item?.key;
    const parts = permId ? permId.split('_') : [];
    const isUnitOrIndicator = (Breadcrumb.isUnitDashboardCrumb(permId) || Breadcrumb.isIndicatorCrumb(permId));
    const hasAlternatives = (this.crumb?.ShortcutItems?.length ?? 0) > 0;
    this._displayShortcuts = this.enableSwitchTo && this.crumb && isUnitOrIndicator && hasAlternatives && parts.length <= 5;
  }

  setCrumbClass() {
    if (this.isactive === true) {
      this.crumbClass = this.crumbClass + ' active';
    }
  }

  onCrumbClicked() {
    if ((this.crumb) && (this.crumb.Item)) {
      this.crumbClicked.emit(this.crumb.Item);
    }
    return false;
  }

  onCrumbSiblingClicked($sibling) {
    const item = $sibling as KeyValue<string, string>;
    this.crumbClicked.emit(item);

    return false;
  }

  unsubscribe() {
    if (this.$subscriptions) {
        this.$subscriptions.unsubscribe();
    }
  }

  ngOnDestroy(): void {
      this.unsubscribe();
  }

}
